export default {
  selectYgTemperatureByList: '/ygsjzs/ygTemperature/selectYgTemperatureByList',
  selectYgTemperatureSwitch: '/ygsjzs/ygTemperature/selectYgTemperatureSwitch',
  updateYgTemperatureSwitch: '/ygsjzs/ygTemperature/updateYgTemperatureSwitch',
  updateYgTemperature: '/ygsjzs/ygTemperature/updateYgTemperature'
}
